<template>
  <div>
    <Card
      :padding="false"
      class="search-card"
    >
      <template slot="header">
        Make a Reservation
      </template>
      <MainForm class="pa-3"/>
      <router-view name="form"/>
      <v-alert
        v-if="$route.path == '/reserve'"
        :value="true"
        dismissible
        type="info"
      >
        <span
          v-html="settings.textHome"
        />
      </v-alert>
    </Card>
    <router-view
      v-if="facilitiesLoaded"
      name="results"
    />
  </div>
</template>

<script>
// import modules
import MainForm from '@/components/reserve/forms/Main'
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
// our new component
export default {
  name: 'Reserve',
  components: {
    MainForm
  },
  data () {
    return {
      date: new Date()
    }
  },
  computed: {
    ...mapGetters({
      facilitiesLoaded: 'facilities/loaded'
    })
  },
  mounted () {
    this.loadFacilities(this.form)
  },
  methods: {
    ...mapActions({
      loadFacilities: 'facilities/loadFacilities'
    })
  }
}
</script>
